import type { KioskMeetingStatus, MeetingInfo } from "./types";

export function applyMeetingCapacity(
  meeting: MeetingInfo,
  status: KioskMeetingStatus | null | undefined
): MeetingInfo {
  if (!status) return meeting;

  const next: MeetingInfo = {
    ...meeting,
    registeredAttendeeLimit: status.registeredAttendeeLimit,
    registeredAttendeeCount: status.registeredAttendeeCount,
    registeredSpeakerLimit: status.registeredSpeakerLimit,
    registeredSpeakerCount: status.registeredSpeakerCount,
    speakersCanRegister:
      status.speakersCanRegister ?? meeting.speakersCanRegister,
    speakerSignupUnavailableReason:
      status.speakerSignupUnavailableReason ??
      meeting.speakerSignupUnavailableReason,
    registrationOpen: status.registrationOpen ?? meeting.registrationOpen,
    registrationUnavailableReason:
      status.registrationUnavailableReason ??
      meeting.registrationUnavailableReason
  };

  return capacityChanged(meeting, next) ? next : meeting;
}

function capacityChanged(a: MeetingInfo, b: MeetingInfo): boolean {
  return (
    a.registeredAttendeeLimit !== b.registeredAttendeeLimit ||
    a.registeredAttendeeCount !== b.registeredAttendeeCount ||
    a.registeredSpeakerLimit !== b.registeredSpeakerLimit ||
    a.registeredSpeakerCount !== b.registeredSpeakerCount ||
    a.speakersCanRegister !== b.speakersCanRegister ||
    a.speakerSignupUnavailableReason !== b.speakerSignupUnavailableReason ||
    a.registrationOpen !== b.registrationOpen ||
    a.registrationUnavailableReason !== b.registrationUnavailableReason
  );
}
